'use client';

import cx from 'classnames';
import { useTranslations } from 'next-intl';
import { Image } from 'components/image';
import { CatButton, CatHeading } from 'components/blocks-components';
import { NOT_FOUND_IMAGE } from '../../app/[lang]/[esite]/(core)/(home)/_components/customer-account/constants';
import { NoResultProps } from './types';
import styles from './no-results.module.scss';

export const NoResults = ({
  imageUrl = NOT_FOUND_IMAGE,
  label,
  noResultLabel,
  noResultTextComponent,
  classname,
  width = 180,
  height = 120,
  componentClassname,
  buttonText,
  buttonAction
}: NoResultProps) => {
  const t = useTranslations();
  return (
    <div
      className={cx(
        'd-flex justify-content-center flex-column align-items-center gap-3',
        styles['no-results'],
        classname
      )}
    >
      <Image
        src={imageUrl}
        alt="image"
        width={width}
        height={height}
        loading="lazy"
      />
      {label && <CatHeading variant="label">{t(label)}</CatHeading>}
      {noResultLabel && (
        <CatHeading variant="body-sm" className="w-25 text-center">
          {t(noResultLabel)}
        </CatHeading>
      )}
      {noResultTextComponent && (
        <p
          data-testid="no-result-text-component"
          className={cx(
            {
              'mb-4': buttonText
            },
            componentClassname
          )}
        >
          {noResultTextComponent}
        </p>
      )}
      {buttonText && buttonAction && (
        <CatButton
          data-testid="action-button"
          variant="contrast"
          onClick={buttonAction}
        >
          {buttonText}
        </CatButton>
      )}
    </div>
  );
};
